
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		let body 		= $( 'body' );
		let header 		= $( 'header' );

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Carousel - Set equal heights to captions on mobile
		 */
		let equalCarouselSlideHeights = function(carouselSelector){

			$(carouselSelector).each(function(){
				var items 		= $(".carousel-item", this);
				let maxHeight 	= 0;

				// Show all slides
				$.each(items, function(i, slide){

					$(this).css("height", "");
					$(".carousel-caption", this).css("height", "");

					$(slide).addClass("active");

				});

				// Get the height of the tallest caption and save it
				$.each(items, function(){

					let caption 		= $(".carousel-caption", this);
					let captionHeight 	= caption.outerHeight();

					if(captionHeight > maxHeight){
						maxHeight = captionHeight;
					}

				});

				// Apply the max height to all captions
				$.each(items, function(){

					if($(window).width() >= parseInt($(":root").css("--breakpoint-lg"))){

						$(this).css("height", maxHeight + 70);

					}else{

						$(".carousel-caption", this).css("height", maxHeight);

					}

					// Remove .active from all slides
					$(this).removeClass("active");

				});

				// Add the active class back to the first slide
				$(".carousel-inner .carousel-item:first-of-type", this).addClass("active");

			});
		};

		equalCarouselSlideHeights(".carousel-block .carousel, .spotlight-carousel-block .spotlight-text-carousel");

		/**
		 * Spotlight carousel
		 */
		$(".spotlight-carousel-block .spotlight-image-carousel").each(function(){

			if($(window).width() >= parseInt($(":root").css("--breakpoint-lg"))){

				if($(this).find(".carousel-item").length === 2){

					$(this).find(".carousel-item").clone().removeClass("active").appendTo($(this).find(".carousel-inner"));

				}

				$(this).find(".carousel-item.active").next().addClass("carousel-item-next");

				$(this).find(".carousel-item:not(.active) .btn-video-modal").prop("disabled", true);

				let numSlides = $(this).find(".carousel-item").length;

				$(this)
					.on("slide.bs.carousel", function(evt){

						if(evt.direction === "left"){

							let nextNextItemIndex = evt.to + 1;

							if(nextNextItemIndex > (numSlides - 1)){
								nextNextItemIndex = 0;
							}

							let nextNextCarouselItem = $(this).find(".carousel-item").eq(nextNextItemIndex);

							nextNextCarouselItem
								.addClass("carousel-item-next-next")
								// This reflows the element, meaning the browser will calculate the styles and layout of the element
								// Any classes added after this will then trigger any transitions associated with the class
								// This avoids any delays caused by the "wait a tick" method
								.outerHeight();

							nextNextCarouselItem.addClass("carousel-item-left");

						}else if(evt.direction === "right"){

							$(this).find(".carousel-item.carousel-item-next").addClass("carousel-item-right");

							$(this).find(".carousel-item.active").addClass("carousel-item-next");

						}

						if($(this).find(".carousel-item").eq(evt.from).has(".btn-video-modal").length > 0){
							$(this).find(".carousel-item").eq(evt.from).find(".btn-video-modal").prop("disabled", true);
						}

					})
					.on("slid.bs.carousel", function(evt){

						if(evt.direction === "left"){

							$(this).find(".carousel-item.carousel-item-next-next")
								.removeClass("carousel-item-next-next carousel-item-left")
								.addClass("carousel-item-next");

						}else if(evt.direction === "right"){

							$(this).find(".carousel-item-right").removeClass("carousel-item-right");

							let oldNextItemIndex = evt.from + 1;

							if(oldNextItemIndex > (numSlides - 1)){
								oldNextItemIndex = 0;
							}

							$(this).find(".carousel-item").eq(oldNextItemIndex)
								.removeClass("carousel-item-next");

						}

						if($(this).find(".carousel-item").eq(evt.to).has(".btn-video-modal").length > 0){
							$(this).find(".carousel-item").eq(evt.to).find(".btn-video-modal").prop("disabled", false);
						}

					});

			}

		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 100){
			body.addClass('sticky-header');
			$('header').addClass('sticky');
		} else {
			body.removeClass('sticky-header');
			$('header').removeClass('sticky');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 100){
				$('body').addClass('sticky-header');
				$('header').addClass('sticky');
			} else {
				$('body').removeClass('sticky-header');
				$('header').removeClass('sticky');
			}
		});

		let headerHeight = header.height();

		$('#content').css('padding-top', headerHeight);

		/**
		 * Mobile Menu - Open/close functionality
		 */
		let mobileMenuContainer 	= header.find('.mobile .menus');
		let mobileMenuBtnContainer	= header.find('.mobile .menu-button-container');
		let mobileMenuOpenBtn		= header.find('.mobile .menu-button-container button.menu-button');
		let mobileMenuCloseBtn		= header.find('.mobile .menu-button-container button.close-button');
		let mobileMenuItems			= header.find('.mobile .menus .mobile-menu .main-menu-container a');

		$.each(mobileMenuItems, function (i, v) {
			$(v).on('click', function() {
				mobileMenuContainer.removeClass('show');
				mobileMenuBtnContainer.removeClass('open');
				body.removeClass('menu-open');
			});
		});

		// Open
		mobileMenuOpenBtn.on('click', function () {
			mobileMenuContainer.addClass('show');
			mobileMenuBtnContainer.addClass('open');
			$('html').addClass('menu-open');
			body.addClass('menu-open');
		});

		// Close
		mobileMenuCloseBtn.on('click', function () {
			mobileMenuContainer.removeClass('show');
			mobileMenuBtnContainer.removeClass('open');
			$('html').removeClass('menu-open');
			body.removeClass('menu-open');
		});

	});
})(jQuery);